import React, {
  useEffect, useMemo, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import NoDataFound from '../../../shared/NoDataFound';
import HorizontalScroll from '../../../shared/HorizontalScroll';
import { getCurrentOrganization } from '../../../../utils/helpers';
import CardSkeleton from '../../../shared/CardSkeleton';
import GET_ALL_COURSES from '../../../../gql/queries/get-all-courses.gql';
import useDebounce from '../../../../hooks/useDebounce';
import Spinner from '../../../../icons/spinner';
import ErrorMessage from '../../../shared/error-fetching';
import { trackEvent } from '../../../../utils/analytics';
import CourseInfiniteScroll from '../../../../hooks/use-graphQL-infinite-scroll';
import CourseCard from './testseries-library-card';

function TestSeriesCard({
  pageType, queryPareamsTag = '', setSelectedTag, queryPareams, isRefetch, clearFilter, searchKey, clearFilterafterSeacrh, selectTestTab,
  onPageFilters, onPageTags,
}) {
  const {
    scope, mode, centreId, examId, streamId, language, type,
  } = queryPareams;
  const router = useRouter();
  const filterArray = useMemo(
    () => [
      { key: 'courseScope', value: selectTestTab || 'testseries' },
      { key: 'mode', value: mode || '' },
      { key: 'centreId', value: centreId || '' },
      { key: 'tagId', value: setSelectedTag || '' },
      { key: 'examId', value: examId || '' },
      { key: 'streamId', value: streamId || '' },
      { key: 'language', value: language || '' },
      { key: 'type', value: type || '' },
    ],
    [mode, centreId, examId, language, scope, streamId, type, setSelectedTag, queryPareamsTag],
  );
  const [filters, setFilters] = useState(filterArray);
  const debouncedSearchKey = useDebounce(searchKey, 2000);
  console.log('setSelectedTag', queryPareams);
  const {
    data: TestSeriesData,
    error,
    loading,
    refetch,
    fetchMore,
  } = useQuery(GET_ALL_COURSES, {
    variables: {
      filters, page: 1, limit: 12,
    },
  });
  console.log('TestSeriesData', filterArray.courseScope);
  const hasNextPage = TestSeriesData?.getCourseList?.hasNextPage;
  const [pageCount, setPageCount] = useState(1);
  const domainName = getCurrentOrganization();

  const typeClasses = {
    Offline: 'bg-[#E3EAFF] text-[#002FFF]',
    Online: 'bg-[#DFF4CE] text-[#264909]',
  };
  const TestSeries = TestSeriesData?.getCourseList?.courses;
  /// filter
  const filteredCourses = useMemo(() => {
    if (queryPareamsTag === 'all' || queryPareamsTag === '') return TestSeries;
    return TestSeries?.filter((course) => course.tags?.some((t) => t.id === queryPareamsTag));
  }, [queryPareamsTag, TestSeries, clearFilter]);

  useEffect(() => {
    if (debouncedSearchKey?.length >= 2) {
      // Clever tab Event
      trackEvent('MockTest_Search_Initiated', {
        timestamp: new Date().getTime(),
        searchQuery: debouncedSearchKey,
        screenName: 'Test series',
      });
      if (Object.values(queryPareams).filter((value) => value !== '').length > 0) {
        const searchFilters = [{ key: 'courseScope', value: selectTestTab }, { key: 'name', value: debouncedSearchKey }];
        setFilters(searchFilters);
        clearFilterafterSeacrh();
      } else {
        const searchFilters = [{ key: 'courseScope', value: selectTestTab }, { key: 'name', value: debouncedSearchKey }];
        setFilters(searchFilters);
        setSelectedTag('');
        // if (pageCount > 1) {
        setPageCount(1);
        // }

        // keep scope in url
        const url = new URL(window.location.href);
        const scopeValue = selectTestTab || url.searchParams.get('scope');
        url.search = '';
        if (scopeValue) {
          url.searchParams.set('scope', scopeValue);
        }
        router.replace(url, undefined, { shallow: true });
        // window.history.pushState(null, '', url);
      }
    } else {
      setFilters(filterArray);
    }
  }, [debouncedSearchKey]);

  useEffect(() => {
    if (debouncedSearchKey) {
      setFilters([{ key: 'courseScope', value: selectTestTab }, { key: 'name', value: debouncedSearchKey }]);
      refetch({ filters, page: pageCount, limit: 12 });
    } else {
      refetch({ filters: filterArray, page: pageCount, limit: 12 });
      console.log('queryPareams', queryPareams);
    }
  }, [filterArray, pageCount, refetch, isRefetch, queryPareams, clearFilter, selectTestTab]);

  const lastPageFiltersStringRef = useRef('');
  const lastPageTagsStringRef = useRef('');

  useEffect(() => {
    if (!onPageFilters) return;
    const pageFilters = TestSeriesData?.getCourseList?.pageFilters;
    const next = pageFilters ? JSON.stringify(pageFilters) : '';
    if (next !== lastPageFiltersStringRef.current) {
      lastPageFiltersStringRef.current = next;
      onPageFilters(pageFilters || null);
    }
  }, [TestSeriesData?.getCourseList?.pageFilters, onPageFilters]);

  useEffect(() => {
    if (!onPageTags) return;
    const pageTags = TestSeriesData?.getCourseList?.tagFilters;
    const next = pageTags ? JSON.stringify(pageTags) : '';
    if (next !== lastPageTagsStringRef.current) {
      lastPageTagsStringRef.current = next;
      onPageTags(pageTags || null);
    }
  }, [TestSeriesData?.getCourseList?.tagFilters, onPageTags]);

  // end filter

  useEffect(() => {
    setPageCount(1);
  }, [setSelectedTag, filterArray]);
  if (searchKey?.length > 1 && debouncedSearchKey?.length < 2) {
    return (
      <div className="flex justify-center items-center">
        <Spinner color="text-customBlue" />
      </div>
    );
  }
  if (loading) {
    return (
      <div className={`${pageType === 'Home' ? 'flex' : 'grid lg:grid-cols-2 grid-cols-1 lg:gap-4 gap-9'}`}>
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
    );
  }
  if (error) {
    <ErrorMessage error={error.message} fullPage />;
  }
  // console.log('Testseriesdata', Testseriesdata?.courses?.[0]?.slug);
  return (
    <div>
      {
        pageType === 'Home' ? (
          <HorizontalScroll>
            <div
              className={`${pageType === 'Home' ? 'flex' : 'grid lg:grid-cols-2 grid-cols-1'
              } lg:gap-6 gap-4 h-full`}
            >
              {
                filteredCourses?.length > 0 ? (
                  <>
                    {filteredCourses.map((course) => (
                      <CourseCard
                        key={course.id}
                        course={course}
                        pageType={pageType}
                        domainName={domainName}
                        typeClasses={typeClasses}
                      />
                    ))}
                  </>
                ) : (
                  <NoDataFound noMsg="No test series found for your selected tag. Try another tag" />
                )
              }

            </div>
          </HorizontalScroll>
        ) : (
          <CourseInfiniteScroll
            selectedTag={queryPareamsTag}
            searchKey={searchKey}
            selectTestTab={selectTestTab}
            pageType={pageType}
            pageStateValue={pageCount}
            PageState={setPageCount}
            data={filteredCourses}
            fetchMore={fetchMore}
            hasNextPage={hasNextPage}
            loading={loading}
            noDatamsg="No test series found"
            renderComponent={(items) => (items.length > 0 ? (
              <HorizontalScroll>
                <div
                  className={`${pageType === 'Home' ? 'flex' : 'grid lg:grid-cols-2 grid-cols-1 lg:px-0 px-4'
                  } lg:gap-6 gap-4 h-full`}
                >
                  {items.map((course) => (
                    <CourseCard
                      key={course.id}
                      course={course}
                      pageType={pageType}
                      domainName={domainName}
                      typeClasses={typeClasses}
                    />
                  ))}
                </div>
              </HorizontalScroll>
            ) : (
              <NoDataFound noMsg="No test series found" />
            ))}
          />
        )
      }
    </div>
  );
}

TestSeriesCard.propTypes = {
  pageType: PropTypes.any,
  setSelectedTag: PropTypes.any,
  isRefetch: PropTypes.bool,
  queryPareams: PropTypes.any,
  queryPareamsTag: PropTypes.string,
  clearFilter: PropTypes.bool,
  searchKey: PropTypes.string,
  clearFilterafterSeacrh: PropTypes.func.isRequired,
  selectTestTab: PropTypes.any,
  onPageFilters: PropTypes.func,
  onPageTags: PropTypes.func,
};

TestSeriesCard.defaultProps = {
  onPageFilters: undefined,
  onPageTags: undefined,
};
export default TestSeriesCard;
